function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "surface1"
}, React.createElement("path", {
  className: "st0",
  d: "M25.4,501h260.3c7.9,0,14.4-6.4,14.4-14.4V456c0-18.7-12-34.7-28.7-40.6v-18.7c0-22.7-18.5-41.2-41.2-41.2 H80.9c-22.7,0-41.2,18.5-41.2,41.2v18.7C23,421.3,11,437.3,11,456v30.6C11,494.6,17.4,501,25.4,501z M80.9,384.2h149.2 c6.9,0,12.5,5.6,12.5,12.5V413H68.4v-16.2C68.4,389.8,74,384.2,80.9,384.2z M39.7,456c0-7.9,6.4-14.4,14.4-14.4H257 c7.9,0,14.4,6.4,14.4,14.4v16.3H39.7V456z"
}), React.createElement("path", {
  className: "st0",
  d: "M176.4,309.9c14.2,18.9,41.3,22.8,60.3,8.5c12.7-9.5,18.6-24.8,16.8-39.5c12.3-2.1,24.3-5.5,35.6-10.2 l134.4,178.5c14.2,18.9,41.3,22.8,60.3,8.5c19-14.3,22.8-41.3,8.5-60.3L357.9,216.9c7.6-9.6,14.2-20.1,19.6-31.4 c13.8,5.8,30.1,4.2,42.6-5.3c19-14.3,22.8-41.3,8.5-60.3l-69.1-91.8c-14.3-19-41.3-22.8-60.3-8.5c-12.7,9.5-18.6,24.8-16.8,39.5 c-54.1,9.2-100.2,43.9-124,93.4c-13.8-5.8-30-4.2-42.6,5.3c-19,14.3-22.8,41.3-8.5,60.3L176.4,309.9z M338,238.1l19.2,25.5 l-22.9,17.3l-19.2-25.5C323.2,250.3,330.9,244.5,338,238.1z M466.6,432.8c-6.3,4.8-15.3,3.5-20.1-2.8l-95-126.2l22.9-17.3l95,126.2 C474.2,419,472.9,428,466.6,432.8z M316.6,42.6c6.3-4.8,15.4-3.5,20.1,2.8l69.1,91.8c4.8,6.3,3.5,15.3-2.8,20.1 c-6.3,4.8-15.3,3.5-20.1-2.8l-69.1-91.8C309,56.4,310.2,47.3,316.6,42.6z M295.6,86.3c6.2,8.3,53.2,70.7,59.5,79.1 c-19.6,47.6-63.5,80.7-114.7,86.3l-59.5-79.1C200.5,124.9,244.3,92,295.6,86.3z M133.1,180.7c6.3-4.8,15.3-3.5,20.1,2.8l69.1,91.8 c0,0,0,0,0,0c4.8,6.3,3.5,15.3-2.8,20.1c-6.3,4.8-15.3,3.5-20.1-2.8l-69.1-91.8C125.5,194.5,126.7,185.5,133.1,180.7z"
}));

var SvgIconMatchedOrders = function SvgIconMatchedOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMatchedOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_matched_orders.172c6976.svg";
export { ForwardRef as ReactComponent };